import { render, staticRenderFns } from "./ModalChavePix.vue?vue&type=template&id=49b24df4&scoped=true&"
import script from "./ModalChavePix.vue?vue&type=script&setup=true&lang=js&"
export * from "./ModalChavePix.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b24df4",
  null
  
)

export default component.exports